import type { Magento2_CurrencyEnum } from '@__generated__/globalTypes';
import FormattedMoney from '@app/components/FormattedMoney';
import messages from '@app/pages/Cart/CartTotals/CartTotals.messages';
import { FormattedMessage } from 'react-intl';

export interface FormattedCostsProps {
  value?: number | null;
  currency?: keyof typeof Magento2_CurrencyEnum | string | null;
}

export const FormattedCosts = ({
  amount,
  isShippingCost = false,
}: {
  amount?: FormattedCostsProps | null;
  isShippingCost?: boolean;
}) =>
  amount && amount.value === 0 ? (
    <FormattedMessage
      // We need to differentiate between free shipping and free price
      // since in some languages they differ (e.g., in FR: Gratuite vs Gratuit).
      {...messages[isShippingCost ? 'freeShipping' : 'freePrice']}
    />
  ) : (
    <FormattedMoney {...amount} />
  );
